import classnames from 'classnames'
import { Tooltip } from 'react-tooltip'

import { BUTTON_ROUND_LG_STYLES } from './ButtonRoundLg'

export const BUTTON_ROUND_SM_STYLES = 'w-[32px] h-[32px] rounded-full flex items-center justify-center hover:opacity-90 disabled:opacity-40'

interface IProps {
  form?: string
  type: 'button' | 'submit' | 'div'
  size?: 'sm' | 'lg'
  loading?: boolean
  disabled?: boolean
  children: any
  className?: string
  callback?: (e?: any) => void
  tooltip?: {
    id: string
    message: string
    place?: any
  }
}

export const ButtonRoundSm = ({ form, type, size = 'sm', loading, disabled, children, className, callback, tooltip }: IProps) => {
  let component = (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={classnames(
        size === 'sm' && BUTTON_ROUND_SM_STYLES,
        size === 'lg' && BUTTON_ROUND_LG_STYLES,
        className,
        disabled && 'opacity-40'
      )}
      onClick={(e) => {
        if (callback) {
          callback(e)
        }
      }}
    >
      {children}
    </div>
  )

  if (type === 'submit') {
    component = (
      <button
        form={form}
        className={classnames(size === 'sm' && BUTTON_ROUND_SM_STYLES, size === 'lg' && BUTTON_ROUND_LG_STYLES, className)}
        type='submit'
        disabled={loading}
      >
        {children}
      </button>
    )
  }

  if (type === 'button') {
    component = (
      <button
        className={classnames(size === 'sm' && BUTTON_ROUND_SM_STYLES, size === 'lg' && BUTTON_ROUND_LG_STYLES, className)}
        type='button'
        disabled={loading || disabled}
        onClick={(e) => {
          if (callback) {
            callback(e)
          }
        }}
      >
        {children}
      </button>
    )
  }

  return tooltip ? (
    <div data-tooltip-id={tooltip.id} data-tooltip-content={tooltip.message}>
      {component}
      {!disabled && (
        <Tooltip id={tooltip.id} place={tooltip.place} className='hidden sm:inline-block !bg-surface !text-text !drop-shadow-sm z-[60]' />
      )}
    </div>
  ) : (
    component
  )
}
